import {Feature, Features} from "../feature"

export const alkylHalideFilter = {
    filterInPlace: (features: Feature[]) => {
        const alkylHalides = features.filter(f => f.name.includes(Features.alklyHalid));
        const acidHalides = features.filter(f => f.name.includes(Features.halide));

        alkylHalides.forEach(alkyl => {
            // If an alkyl halide is part of an acid halide, it should be removed.
            const parentAcid = acidHalides.find(acid => alkyl.atoms.every(a => acid.atoms.includes(a)))
            if(parentAcid) {
                features.splice(features.indexOf(alkyl), 1);
            }
        })

        return features;

    }
}